import React from 'react';
import PropTypes from 'prop-types';
import application_contants from '../../contants/application_contants';


export default function FooterHack4TTS({ section_id }) {
  return (
    <footer id={section_id} className="footer-hack4tts">
      {/* Top nav + logo */}
     <div className="footer-logo h1-medium section-title title-navy-blue pb-2 title">Voice Tech for All </div>
      {/* Divider */}
      <hr className="footer-divider" />
      {/* Partner logos */}
      <div className="footer-partners">
        <img src={application_contants.iisclogo }      alt="IISc"      />
        <img src={application_contants.artparklogo }   alt="Artpark"   />
        <img src={application_contants.bhashinilogo } alt="Bhashini" />
        <img src={application_contants.gizlogo }       alt="GIZ"       />
        <img src={application_contants.spirelogo } alt="Spire Lab" />
        <img src={application_contants.armmanlogo }   alt="Armman"   />
      </div>

      {/* Divider */}   
      <hr className="footer-divider" />
    </footer>
  )
}

FooterHack4TTS.propTypes = {
  section_id: PropTypes.string.isRequired
}
